<script lang="ts" setup>
import { Select, RadioGroup } from '@skillstown/leap';
import { useI18n } from 'vue-i18n';
import { User } from '~~/data/resources/User';
import { AuthService } from '~~/data/services/AuthService';
import { useUser } from '~~/stores/user';

const localeOptions = [
  {
    value: 'nl',
    label: 'Nederlands (Dutch)',
  },
  {
    value: 'en',
    label: 'English (Engels)',
  },
];

const i18n = useI18n();
const user = useUser();

onMounted(async () => {
  i18n.locale.value = user.locale || 'nl';
});

async function submitLocaleChange(): Promise<void> {
  await new User().setLocale(i18n.locale.value);
  await AuthService.instance.tryFetchAndSetUser();
}
</script>

<template>
  <div class="navigation__locale-switch z-25">
    <RadioGroup v-model="$i18n.locale" :options="localeOptions" @change="submitLocaleChange" color="brand" />
  </div>
</template>

<style scoped lang="postcss">
.navigation__locale-switch {
  @apply flex flex-row items-center;
}
</style>
